import React from "react";
import { Button, Modal, Message, Grid } from "semantic-ui-react";
import moment from "moment";
moment.locale("fr");
const styles = {
	patientLabelGrid: {
		textAlign: "right",
		paddingRight: "10px",
	},
	patientValueGridOld: {
		textAlign: "left",
		backgroundColor: "rgba(255, 0, 0, 0.1)",
	},
	patientValueGridNew: {
		textAlign: "left",
		backgroundColor: "rgba(0, 128, 0, 0.1)",
	},
	titleGrid: {
		textAlign: "left",
		fontWeight: "bold",
	},
};

const IdentitoVigilanceEditPatientModal = ({ open, close, submit, patientOld, patientNew }) => {
	return (
		<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>! Modification de données sensibles !</Modal.Header>
			<Modal.Content>
				<Message color="red" style={{ fontSize: "0.9em" }}>
					<div>
						<div>Vous êtes en train de modifier des données sensibles du patient. </div>
						<div style={{ textTransform: "uppercase", fontWeight: "bold", margin: "25px 0", textDecoration: "underline" }}>
							Etes-vous sûr de vouloir modifier ce patient ?{" "}
						</div>
						<div>Cela aura un impact sur tous les dossiers de ce patient. </div>
						<div style={{ fontWeight: "bold", margin: "40px 0 15px", textDecoration: "underline" }}>
							<span style={{ textTransform: "uppercase" }}>Le patient sélectionné </span>(correspondant aux « Anciennes données »){" "}
							<span style={{ textTransform: "uppercase" }}>n’est pas le patient à prélever ?</span>
						</div>
						<div>Annulez le dossier et recommencez une recherche patient.</div>
					</div>
				</Message>
				<Grid key={`grid-${patientNew.id}`} style={{ padding: "65px 5px" }}>
					<Grid.Row columns={3}>
						<Grid.Column style={styles.patientLabelGrid}> </Grid.Column>
						<Grid.Column style={styles.titleGrid}> Anciennes données </Grid.Column>
						<Grid.Column style={styles.titleGrid}> Données mises à jour </Grid.Column>
						{patientOld.birth_name !== patientNew.birth_name && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Nom de naissance: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}> {patientOld.birth_name || "-"}</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}> {patientNew.birth_name || "-"}</Grid.Column>
							</>
						)}
						{patientOld.first_name !== patientNew.first_name && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Prénom(s): </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}> {patientOld.first_name || "-"}</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}> {patientNew.first_name || "-"}</Grid.Column>
							</>
						)}
						{patientOld.gender !== patientNew.gender && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Genre: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}>
									{patientOld.gender === "m" && "Homme"} {patientOld.gender !== "m" && "Femme"}
								</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}>
									{patientNew.gender === "m" && "Homme"} {patientNew.gender !== "m" && "Femme"}
								</Grid.Column>
							</>
						)}
						{patientOld.birth_date !== patientNew.birth_date && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Date de naissance: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}>
									{patientOld.birth_date ? moment(patientOld.birth_date).format("DD MMMM YYYY") : "non communiquée"}
								</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}>
									{patientNew.birth_date ? moment(patientNew.birth_date).format("DD MMMM YYYY") : "non communiquée"}
								</Grid.Column>
							</>
						)}
						{(patientOld.cns || patientNew.cns) && patientOld.cns !== patientNew.cns && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Matricule: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}>{patientOld.cns || "non communiqué"}</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}>{patientNew.cns || "non communiqué"}</Grid.Column>
							</>
						)}
						{(patientOld.mobile_phone || patientNew.mobile_phone) && patientOld.mobile_phone !== patientNew.mobile_phone && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Téléphone: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}>{patientOld.mobile_phone || "non communiqué"} </Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}>{patientNew.mobile_phone || "non communiqué"} </Grid.Column>
							</>
						)}
						{(patientOld.email || patientNew.email) && patientOld.email !== patientNew.email && (
							<>
								<Grid.Column style={styles.patientLabelGrid}> Email: </Grid.Column>
								<Grid.Column style={styles.patientValueGridOld}>{patientOld.email || "non communiqué"}</Grid.Column>
								<Grid.Column style={styles.patientValueGridNew}>{patientNew.email || "non communiqué"}</Grid.Column>
							</>
						)}
					</Grid.Row>
				</Grid>
			</Modal.Content>

			<Modal.Actions>
				<Button
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						close();
					}}
				>
					Annuler
				</Button>
				<Button
					primary
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						submit();
					}}
				>
					Je confirme modifier les données de ce patient
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default IdentitoVigilanceEditPatientModal;
